// 赛道介绍
import { RootObject, Content3 } from '../../type';
import './style.less';

const TrackIntroduction = (props: RootObject["trackIntroduction"]) => {
    const {
        zhTitle,
        enTitle,
        content
    } = props;
    return (
        <div className='p-p-foundathon-trackIntroduction'>
            <div className='p-p-foundathon-trackIntroduction-zh-title'>
                {
                    zhTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-trackIntroduction-en-title'>
                {
                    enTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-trackIntroduction-modules'>
                {
                    content.map((item: Content3, index: number) => {
                        return (
                            <div className='p-p-foundathon-trackIntroduction-modules-module' key={index} onClick={() => window.open(item.skip.skipLink)} >
                                <div className='p-p-foundathon-trackIntroduction-modules-module-back'>
                                    <img src={item.backImg} alt="" className='p-p-foundathon-trackIntroduction-modules-module-back-img' />
                                </div>
                                <div className='p-p-foundathon-trackIntroduction-modules-module-content'>
                                    <div className='p-p-foundathon-trackIntroduction-modules-module-content-zh-title'>
                                        {
                                            item.zhTitle ?? ''
                                        }
                                    </div>
                                    <div className='p-p-foundathon-trackIntroduction-modules-module-content-en-title'>
                                        {
                                            item.enTitle ?? ''
                                        }
                                    </div>
                                    <div className='p-p-foundathon-trackIntroduction-modules-module-desc'>
                                        {
                                            item.desc ?? ''
                                        }
                                    </div>
                                    <div className='p-p-foundathon-trackIntroduction-modules-module-skips'>
                                        {item.skip.skipName}
                                       <img src={item.arrowImg} alt="" className='p-p-foundathon-trackIntroduction-modules-module-skips-arrow'/>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default TrackIntroduction;